import React, { memo } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default memo(function AnswerTitle({ title, number }) {
  const { t } = useTranslation();
  return <div className="insight-answer-title">{`${number}. ${t(title)}`}</div>;
});
